var React = require('react');

function ListDot (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4","cy":"4","r":"4","fill":"#EF843B"}));
}

ListDot.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = ListDot;

ListDot.default = ListDot;
